import { render } from "./AddressField.vue?vue&type=template&id=fbbbed0a"
import script from "./AddressField.vue?vue&type=script&lang=ts"
export * from "./AddressField.vue?vue&type=script&lang=ts"
script.render = render

export default script